/**
 * antd's `form.validateFields()` rejects with `{ errorFields, ... }` when a
 * client-side rule fails; anything else is a request / runtime error.
 */
export const isFormValidationError = (e: unknown): boolean =>
  typeof e === 'object' && e !== null && 'errorFields' in e;
